var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "61px",
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9BBA67B1-ACBA-4794-AEA3-0ADE8CA5F6BF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editing-profile---desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D/profile_page",
    transform: "translate(-471.000000, -959.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/system/play",
    transform: "translate(471.003469, 959.960106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.996531,0.039893617 C13.4276868,0.039893617 -0.00346901018,13.4710494 -0.00346901018,30.0398936 C-0.00346901018,46.6087378 13.4276868,60.0398936 29.996531,60.0398936 C46.5653752,60.0398936 59.996531,46.6087378 59.996531,30.0398936 C59.996531,13.4710494 46.5653752,0.039893617 29.996531,0.039893617 Z",
    id: "circle",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle",
    points: "20.1003044 42.8663317 20.1003044 17.1336683 45.4822052 30"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.bd3257f1cb05071cd30765ec10f20967.svg";
export { ForwardRef as ReactComponent };